<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { throttle } from 'lodash-es';
import SkistarAccommodationsMapping from './SkistarAccommodationsMapping';
import SkistarResortsSelect from './SkistarResortsSelect';

export default {
  name: 'SkistarAccommodationFilter',
  components: {
    SkistarAccommodationsMapping,
    SkistarResortsSelect,
  },
  props: {
    selectedAccommodations: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      accommodationsLoading: state => state.skistar.accommodations.itemsLoading,
      resortsLoading: state => state.skistar.resorts.itemsLoading,
      subareas: state => state.skistar.accommodations.subareas,
      filterImportStatus: state => state.skistar.accommodations.filterImportStatus,
      filterImageStatus: state => state.skistar.accommodations.filterImageStatus,
    }),
    ...mapGetters({
      importStatusItems: 'skistar/getSkistarImportStatusItems',
      imageStatusItems: 'skistar/getSkistarImageStatusItems',
    }),
  },
  methods: {
    ...mapActions({
      search: 'skistar/searchAccommodations',
      setSubarea: 'skistar/setSubarea',
      setImportStatusFilter: 'skistar/setImportStatusFilter',
      setImageStatusFilter: 'skistar/setImageStatusFilter',
    }),
    throttleInput: throttle(function input(search) {
      this.search(search);
    }, 250, { leading: false }),
  },
};
</script>

<template>
  <div>
    <v-layout row wrap>
      <v-flex xs4>
        <skistar-resorts-select />
      </v-flex>
      <v-flex xs4 pl-4>
        <v-autocomplete
          @change="setSubarea"
          :items="subareas"
          :loading="resortsLoading || accommodationsLoading"
          :disabled="resortsLoading || accommodationsLoading"
          :label="$t('skistar.accommodations.subareaLabel')"
          clearable
        />
      </v-flex>
      <v-flex xs3 pl-4 class="text-xs-right">
        <skistar-accommodations-mapping
          :selected-accommodations="selectedAccommodations"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs4>
          <v-text-field
            @input="throttleInput"
            :disabled="resortsLoading || accommodationsLoading"
            :label="$t('skistar.accommodations.searchLabel')"
            append-icon="search"
            clearable
          />
      </v-flex>
      <v-flex xs4 pl-4>
        <v-select
          @change="setImportStatusFilter"
          :items="importStatusItems"
          :value="filterImportStatus"
          label="Import status"
        />
      </v-flex>
      <v-flex xs4 pl-4>
        <v-select
          @change="setImageStatusFilter"
          :items="imageStatusItems"
          :value="filterImageStatus"
          label="Image status"
        />
      </v-flex>
    </v-layout>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationFilter.vue